import { Box, Stack, IconButton } from "@mui/material";
import { Result } from "antd";
import ReactMarkdown from "react-markdown";
import { sxResultViewBox } from "../pages/LandingPage-sx";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";

export default function ResultDataView(
  resultData: string,
  callAi: () => {},
  downloadPDF: () => void,
  resultViewRef: React.RefObject<HTMLDivElement>,
  clearAll: () => void
) {
  return (
    <Box sx={sxResultViewBox}>
      <div ref={resultViewRef}>
        <Result
          status="success"
          extra={[
            <div className="text-left" style={{ textAlign: "left" }}>
              <ReactMarkdown className="left-aligned">
                {resultData}
              </ReactMarkdown>
              ,
            </div>,
          ]}
        />
      </div>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Stack direction="row" spacing={1}>
          <IconButton onClick={clearAll} title="Reiniciar">
            <DeleteIcon fontSize="medium" sx={{ color: "black" }} />
          </IconButton>
          <IconButton onClick={callAi} title="Refazer">
            <ReplayOutlinedIcon fontSize="medium" sx={{ color: "black" }} />
          </IconButton>
          <IconButton title="Baixar" onClick={downloadPDF}>
            <FileDownloadOutlinedIcon
              fontSize="medium"
              sx={{ color: "black" }}
            />
          </IconButton>
        </Stack>
      </Box>
    </Box>
  );
}
